module.exports = __webpack_public_path__ + "static/img/preview-04.8e5264cd.webp";